import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedFeatureModulesComponentSwitcherModule } from '@digilize/shared/feature/modules/component-switcher';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material/src';
import { SharedUtilsDirectivesModule } from '@digilize/shared/utils/directives/src';
import { SharedUtilsPipesModule } from '@digilize/shared/utils/pipes/src';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SafePipeModule } from 'safe-pipe';

import { DialogNoUserComponent } from './dialog-no-user/dialog-no-user.component';
import { DialogPagesInfoComponent } from './dialog-pages-info/dialog-pages-info.component';
import { DialogPagesComponent } from './dialog-pages/dialog-pages.component';
import { DialogPwdForgotComponent } from './dialog-pwd-reset/dialog-pwd-reset.component';
import { DialogResetPasswordComponent } from './dialog-reset-password/dialog-reset-password.component';
import { DialogSigninComponent } from './dialog-signin/dialog-signin.component';
import { DialogSignupComponent } from './dialog-signup/dialog-signup.component';
import { DialogUpdateFbDetailsComponent } from './dialog-update-fb-details/dialog-update-fb-details.component';
import { ResetPasswordFormComponent } from './reset-password-form/reset-password-form.component';
import { SignInUpComponent } from './sign-in-up/sign-in-up.component';
import { DialogLostSessionComponent } from './dialog-lost-session/dialog-lost-session.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { provideTranslocoScope, TranslocoModule } from '@ngneat/transloco';

const COMPONENTS = [
  DialogSigninComponent,
  DialogPwdForgotComponent,
  DialogPagesInfoComponent,
  DialogSignupComponent,
  DialogUpdateFbDetailsComponent,
  DialogPagesComponent,
  ResetPasswordFormComponent,
  DialogResetPasswordComponent,
  DialogNoUserComponent,
  SignInUpComponent,
  DialogLostSessionComponent,
];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    CommonModule,
    InlineSVGModule,
    HttpClientModule,
    SharedUiMaterialModule,
    SharedUiComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedUtilsDirectivesModule,
    SafePipeModule,
    NgxCaptchaModule,
    SharedUtilsPipesModule,
    SharedFeatureModulesComponentSwitcherModule,
    TranslocoModule,
  ],
  providers: [provideTranslocoScope({ scope: 'auth', alias: 'auth' })],

  exports: [COMPONENTS],
})
export class SharedFeatureModulesLoginModule {}
